module.exports = __webpack_public_path__ + "img/7-bn.e0e3d6a9.png";